import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import H5HelpCenter from './H5';
import WebHelpCenter from './Web';
import LoginHelp from './components/LoginHelp';
import SafeHelp from './components/SafeHelp';


class Help extends React.Component {
    constructor() {
        super();
        this.state = {
            radio: 'login',
        };
    }

    onChange = e => {
        this.setState({radio: e?.target?.value ?? 'login'});
    };

    onClose = () => {
        const {history} = this.props;
        history.goBack();
    };

    render() {
        const {radio} = this.state;
        const {agent: {isMobile}} = this.props;
        let view = null;
        if (radio === 'login') {
            view = <LoginHelp />;
        }
        else if (radio === 'safe') {
            view = <SafeHelp />;
        }
        return (
            isMobile
                ? (
                    <H5HelpCenter radio={radio} onChange={this.onChange}>
                        {view}
                    </H5HelpCenter>
                )
                : (
                    <WebHelpCenter radio={radio} onChange={this.onChange} onClose={this.onClose}>
                        {view}
                    </WebHelpCenter>
                )

        );
    }
}

Help.propTypes = {
    history: PropTypes.shape({
        goBack: PropTypes.func.isRequired,
    }).isRequired,
    agent: PropTypes.shape({
        isMobile: PropTypes.bool.isRequired
    }).isRequired,
};

export default withRouter(connect(({agent}) => ({agent}))(Help));
